import { Box } from "@mui/material";

const NavigationHeader = () => {
  return (
    <Box display="flex" alignItems="center" gap="1rem" padding="8px 0px">
      <Box
        component="img"
        src="/assets/eezy_logo2.svg"
        sx={{ width: "40px", height: "40px" }}
      />
    </Box>
  );
};

export default NavigationHeader;
